import { getPracticeFeatures } from '@packages/practice-config';
import { useAccount } from '../lib/account/useAccount';

/** Keep invoice actions hidden until the account's practice type is known. */
export function useInvoicingVisible(): boolean | null {
  const { account, isLoading, isError } = useAccount();
  if (isLoading || isError) return null;
  return getPracticeFeatures(account?.practiceSettings?.practiceType).invoicing;
}
